import React from 'react'

const FilterIcon = () => (
	<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" fill="none"><path d="M7.037 11.129v5.981c0 .661.736 1.091 1.362.795l2.044-.966c.319-.151.52-.459.52-.795v-5.015l6.877-9.747c.417-.591-.031-1.382-.783-1.382h-16.115c-.752 0-1.2.792-.783 1.382l6.877 9.747zm6.773-7.419h-9.62l-1.374-1.855h12.27l-1.276 1.855z" fill="#01669A"/></svg>
)

export default FilterIcon
